import Tooltip from 'tooltip.js'

const tooltips = document.querySelectorAll('.js-tooltip')

tooltips.forEach(tooltip => {
  new Tooltip(tooltip, {
    title: tooltip.getAttribute('data-tooltip'),
    placement: 'top-end'
  })
})

const days = document.querySelectorAll('.program__day')
const spaces = document.querySelectorAll('.program__spaces')
const hash = window.location.hash.substr(1);

if (hash) {
  const hashDay = document.querySelector(`[data-target="${hash}"]`)

  if (hashDay) {
    days.forEach(day => {
      day.classList.remove('is-active')
      hashDay.classList.add('is-active')
    })
    spaces.forEach(space => {
      space.classList.remove('is-active')
      document.getElementById(hash).classList.add('is-active')
    })
  }
}

days.forEach(button => {
  button.addEventListener('click', e => {
    e.preventDefault()
    window.location.hash = button.dataset.target;
    days.forEach(day => {
      day.classList.remove('is-active')
      button.classList.add('is-active')
    })
    spaces.forEach(space => {
      space.classList.remove('is-active')
      document.getElementById(button.dataset.target).classList.add('is-active')
    })
  })
})

